import yup from '../../../config/yup';

export const element451WriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('element451Writer'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  onError: yup.string(),
  properties: yup.object().shape({
    client: yup
      .string()
      .required('Client is required')
      .transform((value) => value?.trim()),
    apiRootUrl: yup.string().transform((value) => value?.trim()),
    source: yup
      .string()
      .required('Source is required')
      .transform((value) => value?.trim()),
    template: yup
      .string()
      .required('Template is required')
      .transform((value) => value?.trim()),
    feature: yup
      .string()
      .required('Feature is required')
      .transform((value) => value?.trim()),
    sleepInMilliSeconds: yup.number(),
  }),
});
